import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { carregarTawk, ocultarTawk } from '../../utils/chatTawk';

/**
 * Carrega o chat do comercial para contas em demonstração.
 *
 * Não renderiza nada: o widget monta a si mesmo no body. Fica dentro do Router,
 * acima das rotas, porque precisa acompanhar a navegação — uma vez carregado, o
 * widget persiste na página, e é preciso escondê-lo ao entrar numa tela
 * pública, não apenas deixar de renderizar um componente.
 *
 * O balão nasce minimizado. Quem decide abrir é o item "Chat ao vivo" do menu,
 * ou um trigger configurado no painel do Tawk.
 */

/** Telas de login, cadastro e recuperação de senha. */
const ehRotaPublica = (caminho) => String(caminho || '').startsWith('/auth');

const ChatDemonstracao = () => {
  const location = useLocation();

  useEffect(() => {
    if (ehRotaPublica(location.pathname)) {
      // Só esconde; descarregar e recarregar a cada navegação custaria uma
      // requisição ao Tawk e perderia a conversa em andamento.
      ocultarTawk();
      return;
    }

    carregarTawk();
  }, [location.pathname]);

  return null;
};

export default ChatDemonstracao;
